import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoveToSlotDirective } from './MoveToSlotDirective';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [MoveToSlotDirective],
  imports: [CommonModule, MatButtonModule],
  exports: [MoveToSlotDirective]
})
export class SharedModule {}
